<section class="container-fluid">
    <div class="row py-2"></div>
    <div class="row d-flex align-items-end">
        <div class="col-md-4 col-lg-3 col-12 mb-2">
            <div class="form-floating">
                <select class="form-select" [(ngModel)]="wagsMonth" (change)="onWagsMonthChange()">
                    <option selected disabled value="">Select a Wags Month</option>
                    <option *ngFor="let month of getAllWagsMonth">{{month}}</option>
                </select>
                <label for="dateInput">List Of Wags Month</label>
            </div>
        </div>

        <div class="col-md-4 col-lg-3 col-12 mb-2">
            <div class="form-floating">
                <select class="form-select" [(ngModel)]="selectedEmployeeName" (change)="filterByEmployee()">
                    <option value="">All Employees</option>
                    <option *ngFor="let name of employeeNames" [value]="name">{{ name }}</option>
                </select>
                <label for="employeeSelect">Employee Name</label>
            </div>
        </div>

        <div class="col-md-4 col-lg-3 col-12 mb-2 d-flex justify-content-end gap-2">

            <button type="button" class="btn btn-primary" (click)="onWagsMonthChange()"> Reload
            </button>

        </div>


        <div class="col-md-4 col-lg-3 col-12 mb-2"></div>
        <div class="col-md-4 col-lg-3 col-12 mb-2 d-flex justify-content-end gap-2">
        </div>
    </div>



    <div class="table-responsive mt-4 table-wrapper-scroll-y tableFixHead">
        <table class="table table-bordered table-rounded text-center">
            <thead class="table-primary">
                <tr>
                    <th>S.No</th>
                    <th>Employee Name</th>
                    <th>Total Working Hours</th>
                    <th>UI Hours</th>
                    <th>Functionality Hours</th>
                    <th>API Hours</th>
                    <th>DB Hours</th>
                    <th>Server <br>Deploy Hours</th>
                    <th>MKU Hours</th>
                    <th>Testing Hours</th>
                    <th>Other Hours</th>
                    <th>View</th>
                </tr>
            </thead>
            <tbody *ngIf="aggregatedData.length > 0; else noDataFound">
                <tr *ngFor="let entry of aggregatedData; let i = index">
                    <td>{{ i + 1 }}</td>
                    <td>{{ entry?.employeeName || '-' }}</td>
                    <td>{{ entry?.totalWorkHours|| "-"}}</td>
                    <td>{{ entry?.uiWorkHours|| '-' }}</td>
                    <td>{{ entry?.functionalityHours|| '-' }}</td>
                    <td>{{ entry?.apiHours|| '-' }}</td>
                    <td>{{ entry?.databaseHours|| '-' }}</td>
                    <td>{{ entry?.deploymentHours|| '-' }}</td>
                    <td>{{ entry?.mkuHours|| '-' }}</td>
                    <td>{{ entry?.testingHoures|| '-' }}</td>
                    <td>{{ entry?.othersHours|| '-' }}</td>
                    <td>
                        <span class="fa far fa-eye text-primary" style="cursor:pointer;"
                            (click)="openModal(entry)"></span>
                    </td>
                </tr>
            </tbody>
            <ng-template #noDataFound>
                <tr>
                    <td colspan="11" class="text-center text-danger fw-bolder">Data Not Found</td>
                </tr>
            </ng-template>
        </table>
    </div>

    <!-- Modal -->
    <div *ngIf="isShowPopup">
        <div class="modal fade show d-block" tabindex="-1" style="background: rgba(0,0,0,0.5);">
            <div class="modal-dialog modal-xxl">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">{{ selectedEmployee?.employeeName }} - Worksheet Details</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
                            (click)="closeModal()"></button>

                    </div>
                    <div class="modal-body">
                        <div class="table-responsive mt-4 table-wrapper-scroll-y tableFixHead">
                            <table class="table table-bordered table-rounded text-center">
                                <thead class="table-primary">
                                    <tr>
                                        <th>S.No</th>
                                        <th>Entry Date</th>
                                        <th>Project Name</th>
                                        <th>Task Type</th>
                                        <th>Description</th>
                                        <th>Start Time</th>
                                        <th>End Time</th>
                                        <th>Total Hours</th>
                                        <th>Payment Status</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let entry of selectedEmployee?.entries;let i = index">
                                        <td>{{ i + 1 }}</td>
                                        <td>{{ entry.entryDate | date: 'dd-MMM-yyyy' }}</td>
                                        <td>{{ entry?.projectName || '-' }}</td>
                                        <td>{{ entry?.taskType || '-' }}</td>
                                        <td>{{ entry?.description || '-' }}</td>
                                        <td>{{ (entry?.startTime | date : 'hh:mm aa') || '-' }}</td>
                                        <td>{{ (entry?.endTime | date : 'hh:mm aa') || '-' }}</td>
                                        <td>{{ entry?.totalHours || '-' }}</td>
                                        <td>

                                            <span class="badge px-3 py-2" [ngClass]="
                                                getPaymentStatus(entry) === 'PAID'
                                                    ? 'bg-success'
                                                    : 'bg-danger'
                                            ">
                                                {{
                                                getPaymentStatus(entry) === 'PAID'
                                                ? 'Paid'
                                                : 'Unpaid'
                                                }}
                                            </span>

                                        </td>

                                        <!-- Action -->
                                        <td>

                                            <button type="button" class="btn btn-sm" [ngClass]="
                                                getPaymentStatus(entry) === 'PAID'
                                                    ? 'btn-warning'
                                                    : 'btn-success'
                                            " [disabled]="
                                                paymentUpdatingId === entry?.devEmployeeTrackId
                                            " (click)="updatePaymentStatus(entry)">

                                                <span *ngIf="
                                                    paymentUpdatingId === entry?.devEmployeeTrackId
                                                " class="spinner-border spinner-border-sm me-1">
                                                </span>

                                                <i *ngIf="
                                                    paymentUpdatingId !== entry?.devEmployeeTrackId
                                                    &&
                                                    getPaymentStatus(entry) !== 'PAID'
                                                " class="fa fa-check me-1">
                                                </i>

                                                <i *ngIf="
                                                    paymentUpdatingId !== entry?.devEmployeeTrackId
                                                    &&
                                                    getPaymentStatus(entry) === 'PAID'
                                                " class="fa fa-undo me-1">
                                                </i>

                                                {{
                                                paymentUpdatingId === entry?.devEmployeeTrackId
                                                ? 'Updating...'
                                                : (
                                                getPaymentStatus(entry) === 'PAID'
                                                ? 'Mark Unpaid'
                                                : 'Mark Paid'
                                                )
                                                }}

                                            </button>

                                        </td>

                                    </tr>

                                    <!-- No records -->
                                    <tr *ngIf="
                                        !selectedEmployee?.entries ||
                                        selectedEmployee?.entries?.length === 0
                                    ">

                                        <td colspan="10" class="text-center text-danger fw-bold py-4">

                                            No Worksheet Details Found

                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</section>